var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNorneLinjeDIkon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 200 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2a2a2a",
  d: "m1.81 138-2.1-2.14L46 90.39a4.42 4.42 0 0 1 5.52-.55L120 134.36a1.44 1.44 0 0 0 1.79-.18l70.86-69.48 2.1 2.14-70.84 69.49a4.44 4.44 0 0 1-5.53.55L49.92 92.36a1.44 1.44 0 0 0-1.79.17Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 48.72,
  cy: 92.61,
  r: 6.83,
  fill: "#2a2a2a"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 121.24,
  cy: 133.31,
  r: 6.83,
  fill: "#2a2a2a"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 192.41,
  cy: 66.69,
  r: 6.83,
  fill: "#2a2a2a"
})));
export default SvgNorneLinjeDIkon;